import { render, staticRenderFns } from "./upZz.vue?vue&type=template&id=242b6678&scoped=true"
import script from "./upZz.vue?vue&type=script&lang=js"
export * from "./upZz.vue?vue&type=script&lang=js"
import style0 from "./upZz.vue?vue&type=style&index=0&id=242b6678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b6678",
  null
  
)

export default component.exports